import { apiClient, getUserId } from "./authService";

interface PromoData {
  [key: string]: any;
}

export const getAdvancedSettings = async (businessId?: string): Promise<any> => {
  try {
    const userId = getUserId();
    if (!userId) throw new Error("User ID not found. Please log in again.");
    
    let url = `/settings/getSettingsAndValues/${businessId}`;
   
    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const updateSettings = async (
  id: string,
  branchData: PromoData
): Promise<any> => {
  try {
    const response = await apiClient.put(`/settings/update/${id}`, branchData);
    return response.data;
  } catch (error) {
    throw error;
  }
};
